import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Cookie } from "lucide-react";

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      // Small delay before showing for better UX
      const timer = setTimeout(() => setShowBanner(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem("cookieConsent", "all");
    setShowBanner(false);
  };

  const handleNecessaryOnly = () => {
    localStorage.setItem("cookieConsent", "necessary");
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] bg-white border-t border-gray-200 shadow-[0_-4px_20px_rgba(0,0,0,0.15)] p-4 md:p-6 animate-in slide-in-from-bottom duration-500">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-center gap-4 md:gap-8">
          {/* Text Content */}
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-2">
              <Cookie className="h-5 w-5 text-[#2D5A4A]" />
              <h3 className="font-bold text-[#2D5A4A] text-lg">We value your privacy</h3>
            </div>
            <p className="text-gray-600 text-sm md:text-base leading-relaxed">
              We use cookies to enhance your browsing experience, analyse site traffic, and improve our services. 
              By clicking "Accept All", you consent to our use of cookies.
            </p>
          </div>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 shrink-0">
            <Button
              onClick={handleNecessaryOnly}
              variant="outline"
              className="h-12 px-6 border-gray-300 text-gray-700 hover:bg-gray-50 font-semibold"
            >
              Necessary Only
            </Button>
            <Button
              onClick={handleAcceptAll}
              className="h-12 px-6 bg-[#2D5A4A] hover:bg-[#234839] text-white font-semibold"
            >
              Accept All
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
